/* istanbul ignore file */
import React, {Dispatch, SetStateAction} from 'react';

import {SelectOption} from '@veneer/core';

import SelectMultipleFilter from './SelectMultipleFilter';

const EditionFilter = <K extends string, F extends Partial<Record<K, string | string[] | Date>>>({
    label,
    field,
    filters,
    setFilters,
    editions,
    loading,
}: {
    label: string;
    field: K;
    filters: F;
    setFilters: Dispatch<SetStateAction<F>>;
    editions: SelectOption<string>[];
    loading: boolean;
}): JSX.Element => {
    // If filters is a string, convert it to an array
    filters[field] = (Array.isArray(filters[field]) ? filters[field] : filters[field] ? [filters[field]] : []) as F[K];

    return (
        <SelectMultipleFilter
            data-testid="edition-filter"
            label={label}
            field={field}
            filters={filters as Partial<Record<K, string[]>>}
            setFilters={setFilters as Dispatch<SetStateAction<Partial<Record<K, string[]>>>>}
            options={editions}
            disabled={loading}
        />
    );
};

export default EditionFilter;
